import React from 'react';
import clsx from 'clsx';
import styles from './ProgressBar.module.scss';
export const ProgressBar = ({ className, progress = 0, size })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.progressBarContainer, styles[size], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.bar,
        style: {
            width: `${progress}%`
        }
    }));
